<template>
  <div id="app">
    <app-header />
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
    <app-footer />
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import { mapGetters, mapActions } from "vuex"
export default {
    name: 'app',
    data() {
        return{
            appName: process.env.VUE_APP_NAME
        }
    },
    mounted() {
        if (this.loggedIn && this.getUserId == false) {
            this.logout();
        }
        window.onbeforeunload = function() {
            return "Dude, are you sure you want to leave? Think of the kittens!";
        }
    },
    computed: {
        ...mapGetters('auth', ['loggedIn', 'isActivity', 'isMemberAdmin', 'getUserId']),
    },
    methods: {
        ...mapActions('auth', ['logout']),
        closeIt() {
            return "what the actual fuck";
        }
    },
    components: {
        'app-header': Header,
        'app-footer': Footer
    }
}
</script>

<style>
#app {
    max-width: 600px;
    margin: 0 auto;
    padding-bottom: 63px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
